import { Dispatch } from 'react';

import axios from 'axios';

import { ReorderSuggestions } from '../utils/types';

export const fetchReorderSuggestion = async ({
  itemID,
  setData,
  setError,
}: {
  itemID: number;
  setData: Dispatch<ReorderSuggestions>;
  setError: Dispatch<Error>;
}) => {
  if (!Number.isInteger(itemID)) {
    setError(new Error('invalid itemID'));
    return;
  }

  try {
    const response = await axios.get(`admin/analytics/item/${itemID}/dynamic-reorder`);
    setData(response.data);
    return;
  } catch (error) {
    setError(error);
  }
};

/**
 * Usage Example
 */
// import { fetchReorderSuggestion } from '../helpers/ReorderSuggestionAPI';
// import { ReorderSuggestions } from '../utils/types';

// const [data, setData] = React.useState<ReorderSuggestions>();
// const [error, setError] = React.useState<Error>();

// React.useEffect(() => {
//   fetchReorderSuggestion({ itemID: id, setData, setError });
// }, []);
